'use client'
import dynamic from 'next/dynamic'
import PlaceholderAscii from './PlaceholderAscii'

// Load the 3D component with special optimization strategy
const ThreeDLoader = dynamic(
  () => import('./ThreeDLoader'),
  { 
    ssr: false,
    loading: () => <PlaceholderAscii />
  }
)

export default function ClientOptimizedModel() {
  return <ThreeDLoader />
} 